var _rect, _line, _circle, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect3, _line2, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateDeviceImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 176,
    viewBox: "0 0 179 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 136.5,
    width: 135,
    height: 71,
    rx: 14.5,
    transform: "rotate(-90 1.5 136.5)",
    fill: "#FFF5F0",
    stroke: "url(#paint0_linear_2656_47031)",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 125.5,
    x2: 41.5,
    y2: 125.5,
    stroke: "#DBE0E6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 67,
    r: 3,
    fill: "#08315F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 100.5,
    width: 135,
    height: 71,
    rx: 14.5,
    fill: "white",
    stroke: "#00ABE8",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.876 150.466C135.699 150.466 142.85 143.392 142.85 134.667C142.85 125.941 135.699 118.867 126.876 118.867C118.054 118.867 110.902 125.941 110.902 134.667C110.902 143.392 118.054 150.466 126.876 150.466Z",
    fill: "url(#paint1_radial_2656_47031)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.22 145.808C132.485 145.808 137.564 140.705 137.564 134.41C137.564 128.115 132.485 123.012 126.22 123.012C119.956 123.012 114.877 128.115 114.877 134.41C114.877 140.705 119.956 145.808 126.22 145.808Z",
    fill: "url(#paint2_radial_2656_47031)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.564 134.407C137.564 144.95 124.406 149.845 117.588 141.798C125.094 146.373 134.808 140.951 134.808 132.048C134.814 129.344 133.856 126.726 132.106 124.664C133.775 125.684 135.154 127.115 136.11 128.822C137.066 130.528 137.567 132.451 137.564 134.407Z",
    fill: "url(#paint3_linear_2656_47031)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.217 144.522C131.933 144.522 136.566 139.995 136.566 134.411C136.566 128.828 131.933 124.301 126.217 124.301C120.502 124.301 115.869 128.828 115.869 134.411C115.869 139.995 120.502 144.522 126.217 144.522Z",
    fill: "url(#paint4_radial_2656_47031)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.568 134.408C136.568 143.637 124.868 148.034 118.529 141.177C125.268 143.995 132.922 139.17 132.922 131.87C132.921 129.367 131.977 126.956 130.278 125.117C132.129 125.87 133.715 127.155 134.834 128.809C135.954 130.463 136.557 132.412 136.568 134.408Z",
    fill: "url(#paint5_linear_2656_47031)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.007 143.256C126.261 143.256 127.277 142.237 127.277 140.979C127.277 139.722 126.261 138.703 125.007 138.703C123.753 138.703 122.736 139.722 122.736 140.979C122.736 142.237 123.753 143.256 125.007 143.256Z",
    fill: "#E6F3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.978 130.018C126.076 128.544 124.764 127.256 123.047 127.143C121.331 127.029 119.86 128.133 119.763 129.607C119.665 131.082 120.977 132.369 122.694 132.483C124.41 132.596 125.881 131.493 125.978 130.018Z",
    fill: "url(#paint6_linear_2656_47031)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.372 133.953C121.873 130.356 121.749 129.286 125.426 128.89C121.778 128.353 121.876 127.31 121.372 123.828C120.99 127.29 120.938 128.399 117.319 128.89C121.001 129.292 120.845 130.352 121.372 133.953Z",
    fill: "#E6F3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9741 150.466C93.7963 150.466 100.948 143.392 100.948 134.667C100.948 125.941 93.7963 118.867 84.9741 118.867C76.1518 118.867 69 125.941 69 134.667C69 143.392 76.1518 150.466 84.9741 150.466Z",
    fill: "url(#paint7_radial_2656_47031)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.318 145.808C90.5827 145.808 95.6613 140.705 95.6613 134.41C95.6613 128.115 90.5827 123.012 84.318 123.012C78.0532 123.012 72.9746 128.115 72.9746 134.41C72.9746 140.705 78.0532 145.808 84.318 145.808Z",
    fill: "url(#paint8_radial_2656_47031)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6612 134.407C95.6612 144.95 82.5041 149.845 75.6855 141.798C83.1915 146.373 92.9056 140.951 92.9056 132.048C92.9114 129.344 91.9533 126.726 90.2032 124.664C91.873 125.684 93.2521 127.115 94.208 128.822C95.1639 130.528 95.6643 132.451 95.6612 134.407Z",
    fill: "url(#paint9_linear_2656_47031)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3151 144.522C90.0303 144.522 94.6633 139.995 94.6633 134.411C94.6633 128.828 90.0303 124.301 84.3151 124.301C78.5999 124.301 73.9668 128.828 73.9668 134.411C73.9668 139.995 78.5999 144.522 84.3151 144.522Z",
    fill: "url(#paint10_radial_2656_47031)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6657 134.408C94.6657 143.637 82.966 148.034 76.627 141.177C83.3659 143.995 91.0199 139.17 91.0199 131.87C91.0189 129.367 90.0749 126.956 88.3758 125.117C90.2266 125.87 91.8122 127.155 92.9319 128.809C94.0516 130.463 94.655 132.412 94.6657 134.408Z",
    fill: "url(#paint11_linear_2656_47031)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1045 143.256C84.3584 143.256 85.375 142.237 85.375 140.979C85.375 139.722 84.3584 138.703 83.1045 138.703C81.8505 138.703 80.834 139.722 80.834 140.979C80.834 142.237 81.8505 143.256 83.1045 143.256Z",
    fill: "#E6F3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0759 130.018C84.1735 128.544 82.8613 127.256 81.145 127.143C79.4286 127.029 77.9581 128.133 77.8604 129.607C77.7628 131.082 79.075 132.369 80.7913 132.483C82.5077 132.596 83.9782 131.493 84.0759 130.018Z",
    fill: "url(#paint12_linear_2656_47031)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.47 133.953C79.9706 130.356 79.847 129.286 83.5234 128.89C79.8755 128.353 79.9733 127.31 79.47 123.828C79.0878 127.29 79.0358 128.399 75.4168 128.89C79.0983 129.292 78.9428 130.352 79.47 133.953Z",
    fill: "#E6F3FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.271 154.276C117.037 154.781 117.255 155.819 116.656 156.513C115.644 157.682 114.426 158.662 113.058 159.402C111.201 160.404 109.124 160.932 107.014 160.937C104.903 160.943 102.824 160.427 100.962 159.433C99.5895 158.701 98.3664 157.728 97.3491 156.563C96.7459 155.872 96.9592 154.833 97.7221 154.325C98.4848 153.815 99.5063 154.034 100.14 154.697C100.832 155.419 101.636 156.03 102.524 156.504C103.903 157.239 105.443 157.621 107.005 157.617C108.568 157.614 110.105 157.223 111.48 156.48C112.366 156.002 113.167 155.386 113.855 154.661C114.486 153.995 115.506 153.771 116.271 154.276Z",
    fill: "#08315F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 97.5,
    width: 141,
    height: 77,
    rx: 16.5,
    stroke: "white",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50.5,
    y1: 131.5,
    x2: 50.5,
    y2: 140.5,
    stroke: "#DBE0E6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.7 13.0125C101.7 13.0125 125.895 11.8053 144.491 33.1344C163.088 54.4636 158.089 76.5975 158.089 76.5975",
    stroke: "#5C6C7F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166 65.4815C165.223 69.3333 160.495 75.4321 158.229 78C157.257 75.2716 154.051 68.8519 149 65",
    stroke: "#5C6C7F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3893 58.3632C17.6084 53.0928 19.3817 46.1455 24.7385 43.2754C29.4008 40.7777 35.4955 42.3632 37.9367 47.223C40.0213 51.3731 38.5857 56.8059 34.3209 58.948C30.7695 60.7319 26.1615 59.4774 24.4373 55.7137C23.0499 52.6862 24.154 48.7521 27.3416 47.355C29.7804 46.2859 32.9304 47.2225 33.9062 49.9164C34.251 50.8681 34.2269 51.929 33.8539 52.86C33.4812 53.791 32.7144 54.6068 31.6325 54.8968C30.9642 55.0757 30.2459 54.9981 29.6155 54.6711C28.9852 54.344 28.4289 53.6578 28.4345 52.787C28.4381 52.2104 28.6691 51.8615 29.0431 51.5217C29.23 51.3519 29.4938 51.1761 29.8685 51.1799C30.2428 51.1837 30.6076 51.4452 30.7902 51.7389L30.7905 51.739C31.0028 52.0814 30.9005 52.5352 30.5618 52.7534C30.3584 52.8782 30.1082 52.8948 29.8921 52.7977C29.8946 53.0762 30.0068 53.2181 30.2827 53.3613C30.564 53.507 30.9948 53.5485 31.2711 53.4744C31.8792 53.3116 32.2782 52.8914 32.5094 52.3144C32.7402 51.7373 32.7579 51.0181 32.545 50.4307C31.8841 48.6069 29.6437 47.944 27.9104 48.7035C25.5375 49.7438 24.6897 52.765 25.7533 55.0858C27.1127 58.0527 30.8292 59.065 33.684 57.6309C37.1788 55.8758 38.3764 51.346 36.6441 47.8976C34.5873 43.8032 29.38 42.4471 25.4103 44.5733C20.8017 47.0423 19.2567 53.0911 21.669 57.663C24.4219 62.8804 31.1265 64.5772 36.207 61.7507C41.9264 58.5688 43.8176 50.9988 40.7199 45.3059C37.2711 38.9676 29.0661 36.9301 22.8757 40.4605L22.8756 40.4609C22.7073 40.5569 22.5087 40.5814 22.3236 40.529C22.1388 40.4767 21.9822 40.3518 21.8885 40.1817C21.6945 39.8281 21.8209 39.3797 22.171 39.1804C29.0513 35.2567 38.1401 37.5117 41.9909 44.5881C45.468 50.9784 43.354 59.4468 36.8993 63.0377C31.1276 66.2487 23.5376 64.3295 20.3895 58.3636L20.3893 58.3632Z",
    fill: "#08315F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3893 75.6717C17.6084 80.9421 19.3817 87.8894 24.7385 90.7596C29.4008 93.2572 35.4955 91.6717 37.9367 86.8119C40.0213 82.6618 38.5857 77.2291 34.3209 75.0869C30.7695 73.303 26.1615 74.5576 24.4373 78.3212C23.0499 81.3487 24.154 85.2828 27.3416 86.6799C29.7804 87.7491 32.9304 86.8124 33.9062 84.1185C34.251 83.1668 34.2269 82.1059 33.8539 81.1749C33.4812 80.2439 32.7144 79.4281 31.6325 79.1381C30.9642 78.9592 30.2459 79.0368 29.6155 79.3638C28.9852 79.6909 28.4289 80.3771 28.4345 81.2479C28.4381 81.8245 28.6691 82.1734 29.0431 82.5132C29.23 82.683 29.4938 82.8588 29.8685 82.855C30.2428 82.8513 30.6076 82.5898 30.7902 82.296L30.7905 82.2959C31.0028 81.9535 30.9005 81.4997 30.5618 81.2815C30.3584 81.1567 30.1082 81.1402 29.8921 81.2372C29.8946 80.9587 30.0068 80.8168 30.2827 80.6736C30.564 80.5279 30.9948 80.4865 31.2711 80.5605C31.8792 80.7233 32.2782 81.1435 32.5094 81.7205C32.7402 82.2976 32.7579 83.0168 32.545 83.6043C31.8841 85.428 29.6437 86.091 27.9104 85.3314C25.5375 84.2911 24.6897 81.2699 25.7533 78.9491C27.1127 75.9822 30.8292 74.9699 33.684 76.404C37.1788 78.1592 38.3764 82.6889 36.6441 86.1373C34.5873 90.2317 29.38 91.5878 25.4103 89.4616C20.8017 86.9926 19.2567 80.9438 21.669 76.3719C24.4219 71.1545 31.1265 69.4577 36.207 72.2842C41.9264 75.4662 43.8176 83.0361 40.7199 88.729C37.2711 95.0674 29.0661 97.1048 22.8757 93.5744L22.8756 93.5741C22.7073 93.478 22.5087 93.4535 22.3236 93.5059C22.1388 93.5582 21.9822 93.6831 21.8885 93.8532C21.6945 94.2068 21.8209 94.6552 22.171 94.8545C29.0513 98.7782 38.1401 96.5232 41.9909 89.4468C45.468 83.0565 43.354 74.5881 36.8993 70.9972C31.1276 67.7862 23.5376 69.7054 20.3895 75.6714L20.3893 75.6717Z",
    fill: "#08315F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2656_47031",
    x1: 0.00000222058,
    y1: 134.917,
    x2: 62.8436,
    y2: 256.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA7E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC461B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2656_47031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.849 134.648) scale(16.373 15.1178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#F1F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#EAF2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#DFF1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#CEEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBEFF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2656_47031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.183 134.376) scale(11.6968 11.4524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#A5CBF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#9AC4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#87B9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#6DAAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#4B95E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#227DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#1877D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2656_47031",
    x1: 124.091,
    y1: 132.784,
    x2: 134.885,
    y2: 141.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#78B0EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#6BA7E7",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#4C94E1",
    stopOpacity: 0.384
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#3384DB",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#1F77D7",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#116ED4",
    stopOpacity: 0.899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0969D3",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0667D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2656_47031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.102 134.417) scale(10.6683 10.1648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#083160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#07305E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#062B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#02244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001F41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2656_47031",
    x1: 133.789,
    y1: 140.606,
    x2: 126.994,
    y2: 135.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#021C39",
    stopOpacity: 0.362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#012347",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2656_47031",
    x1: 119.763,
    y1: 129.607,
    x2: 125.999,
    y2: 132.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FF",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2656_47031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.947 134.648) scale(16.373 15.1178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#F1F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#EAF2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#DFF1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#CEEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBEFF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2656_47031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.2803 134.376) scale(11.6968 11.4524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#A5CBF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#9AC4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#87B9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#6DAAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#4B95E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#227DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#1877D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2656_47031",
    x1: 82.1883,
    y1: 132.784,
    x2: 92.9825,
    y2: 141.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#78B0EA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#6BA7E7",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#4C94E1",
    stopOpacity: 0.384
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#3384DB",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#1F77D7",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#116ED4",
    stopOpacity: 0.899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0969D3",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0667D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2656_47031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.1994 134.417) scale(10.6683 10.1648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#083160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#07305E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#062B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#02244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001F41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2656_47031",
    x1: 91.8868,
    y1: 140.606,
    x2: 85.0912,
    y2: 135.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#021C39",
    stopOpacity: 0.362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#012347",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2656_47031",
    x1: 77.8604,
    y1: 129.607,
    x2: 84.0964,
    y2: 132.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FF",
    stopOpacity: 0.56
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateDeviceImage);
export default __webpack_public_path__ + "static/media/rotate-device-image.402f66058c63a8b8798fe0a76475221c.svg";
export { ForwardRef as ReactComponent };